mutation UpdateBillingInfo($input: BillingInfoUpdateInput!) {
    billingInfoUpdate(input: $input) {
        success
    }
}
